<template>
    <share-entity-dialog ref="base" collection="prescriptions" :title="$t('common.share_prescription')"
        :shared-toast="$t('common.prescription_shared')" />
</template>

<script>
import ShareEntityDialog from "./ShareEntityDialog";

export default {
    name: "SharePrescriptionDialog",
    components: { ShareEntityDialog },
    methods: {
        show(entity) {
            this.$refs.base.show(entity)
        },
    }
}
</script>
